var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "truck") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.047 9.973l-2.333-3.333c-0.275-0.389-0.723-0.64-1.229-0.64h-3.735v-2.25c-0.001-0.828-0.672-1.499-1.5-1.5h-12c-0.828 0.001-1.499 0.672-1.5 1.5v15.375h2.488c0.276 1.502 1.575 2.625 3.137 2.625s2.861-1.123 3.134-2.605l0.003-0.020h4.976c0.276 1.502 1.575 2.625 3.137 2.625s2.861-1.123 3.134-2.605l0.003-0.020h2.488v-8.507c0-0.001 0-0.001 0-0.002 0-0.241-0.076-0.464-0.206-0.647l0.002 0.003zM2.25 3.75h12v8.25h-12l-0.001-8.25zM6.375 20.25c-0.932 0-1.688-0.756-1.688-1.688s0.756-1.688 1.688-1.688c0.932 0 1.688 0.756 1.688 1.688v0c-0.001 0.932-0.756 1.686-1.687 1.688h-0zM17.625 20.25c-0.932 0-1.688-0.756-1.688-1.688s0.756-1.688 1.688-1.688c0.932 0 1.688 0.756 1.688 1.688v0c-0.001 0.932-0.756 1.686-1.687 1.688h-0zM21.75 17.625h-1.078c-0.414-1.314-1.621-2.25-3.047-2.25s-2.633 0.936-3.040 2.227l-0.006 0.023h-5.157c-0.414-1.314-1.621-2.25-3.047-2.25s-2.633 0.936-3.040 2.227l-0.006 0.023h-1.078v-4.125h19.5zM21.75 12h-6v-4.5h3.735l2.265 3.236z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.1e557fa9c9c91dd776742e879187dddd.svg";
export { ForwardRef as ReactComponent };